import { Box, Divider } from "@mui/material"
import { ReactNode } from "react"
import { format } from "date-fns"
import TodayIcon from '@mui/icons-material/Today'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

interface ConsumoCardProps {
  icon: ReactNode
  title: string
  valueHoje: number
  valueMensal: number
}

export const ConsumoCard = ({ 
  icon, 
  title, 
  valueHoje, 
  valueMensal, 
}: ConsumoCardProps) => {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 220,
        backgroundColor: 'white',
        borderRadius: 1,
        boxShadow: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
        {icon}
        <Box component="h2" sx={{
          fontSize: '1rem',
          fontWeight: 'bold',
          color: 'primary.main',
          m: 0,
          ml: 1
        }}>
          {title}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            <CalendarMonthIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
            <Box component="p" sx={{
              fontSize: '0.75rem',
              color: 'text.secondary',
              m: 0,
              fontWeight: 'medium'
            }}>
              MENSAL - {format(new Date(), 'MM/yyyy')}
            </Box>
          </Box>
          <Box component="p" sx={{
            fontSize: '1.25rem',
            fontWeight: 'bold',
            m: 0,
            lineHeight: 1.2
          }}>
            {valueMensal.toLocaleString('pt-BR')}
          </Box>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            <TodayIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
            <Box component="p" sx={{
              fontSize: '0.75rem',
              color: 'text.secondary',
              m: 0,
              fontWeight: 'medium'
            }}>
              HOJE
            </Box>
          </Box>
          <Box component="p" sx={{
            fontSize: '1.25rem',
            fontWeight: 'bold',
            m: 0,
            lineHeight: 1.2
          }}>
            {valueHoje.toLocaleString('pt-BR')}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}